//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[0,"CreateTraceLines",1,0],[0,"Divisions",1,0],[0,"Layer",1,0],[0,"LayerOption",1,0],[0,"MoveObjectResult",1,0],[0,"MoveParents",1,0],[0,"NumberOfCopies",1,0],[1,"ObjectToMoveObject",0,"SelectNXObjectList",0],[0,"PreMultiplicationTransform",1,0],[1,"TransformMotion",0,"GeometricUtilities.ModlMotion",0]],[],[]];
SPLM.Features.MoveObjectBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MoveObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MoveObjectBuilder.MoveObjectResultOptions = Object.freeze({
    "MoveOriginal" : "MoveOriginal", "CopyOriginal" : "CopyOriginal"});

SPLM.Features.MoveObjectBuilder.LayerOptionType = Object.freeze({
    "Original" : "Original", "Work" : "Work", "AsSpecified" : "AsSpecified"});

export default SPLM;